export const LOCALE_MAPPINGS = {
    'ar-SA': 'ar-sa',
    'de-DE': 'de',
    'en-US': 'en',
    'es-ES': 'es',
    'fr-FR': 'fr',
    'id-ID': 'id',
    'it-IT': 'it',
    'ja-JP': 'ja',
    'ko-KR': 'ko',
    'pt-BR': 'pt-br',
    'ru-RU': 'ru',
    'th-TH': 'th',
    'tr-TR': 'tr',
    'vi-VN': 'vi',
    'zh-CN': 'zh-cn',
    'zh-TW': 'zh-tw',
};
export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_INPUT_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
